export default "__VITE_ASSET__Cf$L3BLL__"